// 电子保函 -> 退保申请
import request from "../../request.js";
let bhNgs = "/baohanNGS";

// 查询退保申请列表
export const getSelectSurrenderList = function(data) {
  return request({
    url: bhNgs + "/selectSurrenderList",
    method: "post",
    requestConfig: {
      hideLoading: true,
    },
    data,
  });
};

// 查询退保申请信息
export const getSelectSurrender = function(data) {
  return request({
    url: bhNgs + "/selectSurrender",
    method: "post",
    requestConfig: {
      hideLoading: true,
    },
    data,
  });
};
